/* @flow */

import DebtorCompany from 'models/companies/debtorCompany';

export default class SellInvoiceTabUploadXmlForm {
  file: ?File;
  deliveredGoods: boolean;

  constructor() {
    this.file = null;
    this.deliveredGoods = false;
  }
}
